import React, { useEffect, useState } from 'react'
import { Select, Table, Checkbox, Form, Col } from 'antd'
const tableRole = (props) => {
  const { setDataRolepermis, dataEdit, disablePage, word } = props
  const [form] = Form.useForm()
  const [menuCheck, setMenuCheck] = useState({
    create: false,
    edit: false,
    view: false,
    delete: false,
  })
  const [stateChange, setStateChange] = useState(false)
  const [selectMenuTask, setSelectMenuTask] = useState()
  const [data, setData] = useState([
    {
      id: 1,
      title: 'project',
      menu: [
        {
          // id : ตาม Database
          id: 2,
          name: word['Your_Project_List'],
        },
        {
          id: 3,
          name: word['All_Project_List'],
        },
        {
          id: 25,
          name: word['All_Project_List_Admin'],
        },
      ],
      permission: {
        menu_id: undefined,
        create: false,
        read: false,
        update: false,
        delete: false,
      },
    },
    {
      id: 2,
      title: 'task',
      menu: [
        {
          id: 4,
          name: word['Your_Task_Inbox'],
        },
        {
          id: 5,
          name: word['All_Task_Inbox'],
        },
      ],
      permission: {
        menu_id: undefined,
        create: false,
        read: false,
        update: false,
        delete: false,
      },
    },
    {
      id: 3,
      title: 'dashboard',
      menu: [
        {
          id: 7,
          name: word['Executive_Dashboard'],
        },
        {
          id: 6,
          name: word['Summary_Dashboard'],
        },
      ],
      permission: {
        menu_id: undefined,
        create: false,
        read: false,
        update: false,
        delete: false,
      },
    },
    {
      id: 4,
      title: 'Professional Skills',
      menu: [
        {
          id: 8,
          name: word['Professional_Skills'],
        },
      ],
      permission: {
        menu_id: 8,
        create: false,
        read: false,
        update: false,
        delete: false,
      },
    },
    {
      id: 5,
      title: 'history',
      menu: [
        {
          id: 21,
          name: word['History'],
        },
      ],
      permission: {
        menu_id: 21,
        create: false,
        read: false,
        update: false,
        delete: false,
      },
    },
    {
      id: 6,
      title: 'Data Analytics',
      menu: [
        {
          id: 22,
          name: word['Data_Analytics'],
        },
      ],
      permission: {
        menu_id: 22,
        create: false,
        read: false,
        update: false,
        delete: false,
      },
    },
  ])
  useEffect(() => {
    if (dataEdit.role_id) {
      setStateChange(true)
      data.map((item, index) => {
        // object instead of array
        item.menu.map((menu) => {
          dataEdit.permission?.map((dataPermis) => {
            if (dataPermis.menu_id === 4) {
              setSelectMenuTask(dataPermis.menu_id)
            }
            if (dataPermis.menu_id === menu.id) {
              Object.keys(dataPermis).map(function (key) {
                item.permission[key] = dataPermis[key]
                form.setFieldsValue({
                  [`select` + index]: dataPermis.menu_id,
                })
              })
            }
          })
        })
      })
      setData([...data])
    }
  }, [dataEdit])
  const dataSource = data.map((item) => ({
    key: item.id,
    id: item.id,
    title: item.title,
    menu: item.menu,
    permission: item.permission,
  }))
  const columns = [
    {
      title: <h5>Menu</h5>,
      dataIndex: 'menu',
      width: 200,
      ellipsis: true,
      render: (text, record, index) => {
        if (index < 3) {
          let place = ''
          if (index === 0) {
            place = 'Select Project List'
          } else if (index === 1) {
            place = 'Select Task Inbox'
          } else {
            place = 'Select Dashboard'
          }
          return (
            <Form className="form_role_permission" form={form}>
              <Form.Item id={`select` + index} name={`select` + index}>
                <Select
                  disabled={disablePage}
                  // ไม่เลือก select แต่ checkbox
                  className={
                    record.permission.menu_id === undefined &&
                      (record.permission.create ||
                        record.permission.read ||
                        record.permission.update ||
                        record.permission.delete)
                      ? 'color-error-border-select'
                      : 'color-border-select'
                  }
                  id={`select` + index}
                  name={`select` + index}
                  style={{ width: 180 }}
                  placeholder={place}
                  onChange={(e) => onSelect(e, record)}
                  allowClear
                >
                  {record.menu.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Form>
          )
        } else if (index === 3) {
          return <span>{word['Professional_Skills']}</span>
        } else if (index === 4) {
          return <span>{word['History']}</span>
        } else {
          return <span>{word['Data_Analytics']}</span>
        }
      },
    },
    {
      title: (
        <Checkbox
          id="all_create_per"
          checked={menuCheck.create}
          key="1"
          value={'Menu_Create'}
          onChange={(e) => onChange(e, data)}
        >
          {word['Create']}
        </Checkbox>
      ),
      dataIndex: 'title',
      width: 100,
      ellipsis: true,
      render: (text, record, index) => {
        return (
          <Checkbox
            id={`create_per` + index}
            value={'create'}
            checked={index !== 0 ? false : record.permission.create}
            onChange={(e) => onChange(e, record, index, text)}
            disabled={index !== 0 ? true : false}
          />
        )
      },
    },
    {
      title: (
        <Checkbox
          id="all_view_per"
          checked={menuCheck.view}
          key="2"
          value={'Menu_View'}
          onChange={(e) => onChange(e, data)}
        >
          {word['View']}
        </Checkbox>
      ),
      dataIndex: 'title',
      width: 100,
      ellipsis: true,
      render: (text, record, index) => {
        return (
          <Checkbox
            id={`view_per` + index}
            value={'view'}
            checked={record.permission.read}
            onChange={(e) => onChange(e, record, index, text)}
          />
        )
      },
    },
    {
      title: (
        <Checkbox
          id="all_edit_per"
          checked={menuCheck.edit}
          key="3"
          value={'Menu_Edit'}
          onChange={(e) => onChange(e, data)}
        >
          {word['Edit']}
        </Checkbox>
      ),
      dataIndex: 'title',
      width: 100,
      ellipsis: true,
      render: (text, record, index) => {
        return (
          <Checkbox
            id={`edit_per` + index}
            value={'edit'}
            checked={
              index === 2 || index === 4 || index === 5 ? false : record.permission.update
            }
            onChange={(e) => onChange(e, record, index, text)}
            disabled={index === 2 || index === 4 || index === 5 ? true : false}
          />
        )
      },
    },
    {
      title: (
        <Checkbox
          id="all_delete_per"
          checked={menuCheck.delete}
          key="4"
          value={'Menu_Delete'}
          onChange={(e) => onChange(e, data)}
        >
          {word['Delete']}
        </Checkbox>
      ),
      dataIndex: 'title',
      width: 100,
      ellipsis: true,
      render: (text, record, index) => {
        return (
          <Checkbox
            id={`delete_per` + index}
            value={'delete'}
            checked={index !== 0 ? false : record.permission.delete}
            onChange={(e) => onChange(e, record, index, text)}
            disabled={index !== 0 ? true : false}
          />
        )
      },
    },
  ]
  const onSelect = (id_menu, record) => {
    //check condition select checkbox
    //clear select
    if (record.title === 'task') {
      setSelectMenuTask(id_menu)
    }
    cancleSelectMenu(id_menu, record)
    data.map((item) => {
      if (record.id === item.id) {
        item.permission.menu_id = id_menu
      }
    })
    setStateChange(true)
    setData([...data])
  }
  const cancleSelectMenu = (id_menu, record) => {
    data.map((item) => {
      if (
        (item.id === record.id && id_menu === undefined) ||
        (item.id === record.id && record.id === 2)
      ) {
        setData([
          ...data,
          (item.permission.create = false),
          (item.permission.read = false),
          (item.permission.update = false),
          (item.permission.delete = false),
        ])
      }
    })
  }
  useEffect(() => {
    setDataRolepermis(data)
  }, [data])
  useEffect(() => {
    if (stateChange === true) {
      let allCheckCreate = true
      let allCheckRead = true
      let allCheckEdit = true
      let allCheckDelete = true
      data.map((item) => {
        if (item.id === 1 && item.permission.create === false) {
          allCheckCreate = false
        }
        if (item.permission.read === false) {
          allCheckRead = false
        }
        if (item.id !== 3 && item.id !== 5 && item.id !== 6) {
          if (item.permission.update === false) {
            allCheckEdit = false
          }
        }
        if (item.id === 1 && item.permission.delete === false) {
          allCheckDelete = false
        }
      })
      if (allCheckCreate === false) {
        setMenuCheck((prev) => ({
          ...prev,
          create: false,
        }))
      } else {
        setMenuCheck((prev) => ({
          ...prev,
          create: true,
        }))
      }
      if (allCheckRead === false) {
        setMenuCheck((prev) => ({
          ...prev,
          view: false,
        }))
      } else {
        setMenuCheck((prev) => ({
          ...prev,
          view: true,
        }))
      }
      if (allCheckEdit === false) {
        setMenuCheck((prev) => ({
          ...prev,
          edit: false,
        }))
      } else {
        setMenuCheck((prev) => ({
          ...prev,
          edit: true,
        }))
      }
      if (allCheckDelete === false) {
        setMenuCheck((prev) => ({
          ...prev,
          delete: false,
        }))
      } else {
        setMenuCheck((prev) => ({
          ...prev,
          delete: true,
        }))
      }
    }
    setStateChange(false)
  }, [stateChange])
  const handleCheckHeaderMenu = (e, record) => {
    setStateChange(true)
    if (e.target.value === 'Menu_Create') {
      setMenuCheck((prev) => ({
        ...prev,
        create: !menuCheck.create,
      }))
      data.map((item) => {
        setData([
          ...data,
          item.id === 1 ? (item.permission.create = e.target.checked) : false,
          item.id === 1 ? (item.permission.read = true) : false,
          item.id === 1 ? (item.permission.update = true) : false,
        ])
      })
    }
    if (e.target.value === 'Menu_View') {
      setMenuCheck((prev) => ({
        ...prev,
        view: !menuCheck.view,
      }))
      data.map((item) => {
        if (e.target.checked === false) {
          setData([
            ...data,
            (item.permission.read = e.target.checked),
            (item.permission.create = e.target.checked),
            (item.permission.update = e.target.checked),
            (item.permission.delete = e.target.checked),
          ])
        } else if (item.id === 2 && selectMenuTask === 4) {
          // 4  ===  your task inbox
          setData([
            ...data,
            (item.permission.read = e.target.checked),
            (item.permission.update = item.permission.read),
          ])
        } else {
          setData([...data, (item.permission.read = e.target.checked)])
        }
      })
    }
    if (e.target.value === 'Menu_Edit') {
      setMenuCheck((prev) => ({
        ...prev,
        edit: !menuCheck.edit,
      }))
      data.map((item) => {
        if (e.target.checked === false) {
          setData([
            ...data,
            (item.permission.update = e.target.checked),
            (item.permission.create = e.target.checked),
          ])
        } else if (item.id === 2 && selectMenuTask === 4) {
          setData([
            ...data,
            item.id !== 3 ? (item.permission.update = e.target.checked) : false,
            item.id !== 3 ? (item.permission.read = item.permission.update) : false,
          ])
        } else {
          setData([
            ...data,
            item.id !== 3 ? (item.permission.update = e.target.checked) : false,
            item.id !== 3 && item.id !== 5 && item.id !== 6
              ? (item.permission.read = true)
              : false,
          ])
        }
      })
    }
    if (e.target.value === 'Menu_Delete') {
      setMenuCheck((prev) => ({
        ...prev,
        delete: !menuCheck.delete,
      }))
      data.map((item) => {
        setData([
          ...data,
          item.id === 1 ? (item.permission.delete = e.target.checked) : false,
          item.id === 1 ? (item.permission.read = true) : false,
        ])
      })
    }
  }
  const onChange = (e, record, index) => {
    handleCheckHeaderMenu(e, record)
    //check box row
    if (e.target.value === 'create') {
      data.map((item) => {
        if (record.id === item.id) {
          setData([
            ...data,
            (item.permission.create = !item.permission.create),
            (item.permission.read = true),
            (item.permission.update = true),
          ])
        }
      })
    } else if (e.target.value === 'view') {
      data.map((item) => {
        if (record.id === item.id) {
          if (record.id === 2 && selectMenuTask === 4) {
            // 4  ===  your task inbox
            setData([
              ...data,
              (item.permission.read = !item.permission.read),
              (item.permission.update = item.permission.read),
            ])
          } else {
            setData([
              ...data,
              (item.permission.read = !item.permission.read),
              (item.permission.create = false),
              (item.permission.update = false),
              (item.permission.delete = false),
            ])
          }
        }
      })
    } else if (e.target.value === 'edit') {
      data.map((item) => {
        if (record.id === item.id) {
          if (record.id === 2 && selectMenuTask === 4) {
            // 4  ===  your task inbox
            setData([
              ...data,
              (item.permission.read = !item.permission.read),
              (item.permission.update = item.permission.read),
            ])
          } else {
            setData([
              ...data,
              (item.permission.update = !item.permission.update),
              (item.permission.read = true),
              (item.permission.create = false),
            ])
          }
        }
      })
    } else {
      data.map((item) => {
        if (record.id === item.id) {
          setData([
            ...data,
            (item.permission.delete = !item.permission.delete),
            (item.permission.read = true),
          ])
        }
      })
    }
    setData([...data])
  }
  const onClickRow = (record) => {
  }
  return (
    <Table
      columns={columns}
      dataSource={dataSource}
      pagination={false}
      onRow={(record) => {
        return {
          onClick: () => onClickRow(record), // click row
        }
      }}
    />
  )
}

export default tableRole
